import { inject, Injectable } from '@angular/core';
import { assert, isDefined } from '@sama/js-core';
import { ObjectState } from '../../../cross-team-shared/annotation/shared/state/object-state';
import { ShapeState } from '../../../cross-team-shared/annotation/shared/state/shape-state';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';
import { ObjectClassService } from './object-class.service';

@Injectable()
export class AnnotationColorService {
  private taskWorkspaceStore = inject(TaskWorkspaceStore);
  private objectClassService = inject(ObjectClassService);

  getShapeColor(shape: ShapeState) {
    const objectId = shape.parentId;
    assert(isDefined(objectId), 'shape must have an objectId');
    const object = this.taskWorkspaceStore.state().objects[objectId];
    assert(object, 'parent object must be defined');
    return this.getObjectColor(object);
  }

  getObjectColor(object: ObjectState) {
    const className = object.class;
    return this.objectClassService.getClassColor(className);
  }
}
